import loc from 'owa-localize';
import { deleteCalendar } from 'owa-calendar-update';
import { getCalendarEntryByCalendarId } from 'owa-calendar-cache';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import { confirmAndDeleteCalendar } from '../actions/calendarActions';
import { orchestrator } from 'satcheljs';
import { logUsage } from 'owa-analytics';
import { getRemoveDeleteConfirmationText } from '../utils/getRemoveDeleteConfirmationText';
import type { LocalCalendarEntry } from 'owa-graph-schema';

orchestrator(confirmAndDeleteCalendar, async actionMessage => {
    const { calendar, onDelete } = actionMessage;
    const calendarEntry = getCalendarEntryByCalendarId(calendar?.calendarId.id);
    const confirmationText = getRemoveDeleteConfirmationText(calendarEntry as LocalCalendarEntry);
    let isDeleted = false;

    const response = await confirm(
        loc(confirmationText.title),
        loc(confirmationText.subtext),
        false,
        {
            okText: loc(confirmationText.label),
            delayCallbackAfterAnimation: true,
        }
    );

    if (response === DialogResponse.ok) {
        logUsage(
            'CalendarDeleted',
            {
                source_1: 'CalendarPicker',
            },
            {
                isCore: true,
            }
        );
        deleteCalendar(calendar);
        isDeleted = true;
    }

    if (onDelete) {
        onDelete(isDeleted);
    }
});
